import React from 'react'
import Immutable from 'immutable';
import styled, {css} from 'styled-components';
import Button from '../../components/forms/button';
import {defaultTheme} from '../../data/themes';
import { ModuleHeader, ModuleHeaderItem } from './moduleheader';

const EMPTY_LIST = Immutable.List([]);

const WizardWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
`;

const Header = styled.div`
	flex-grow: 0;
	flex-shrink: 0;
`;

const Content = styled.div`
	flex-grow: 1;
	flex-shrink: 1;
	overflow: auto;
`;

const Buttons = styled.div`
	flex-grow: 0;
	flex-shrink: 0;

	[data-name=next] {
		float: right;
	}

	[data-name=invisible] {
		visibility: hidden;
	}
	padding: 4px 16px;
`;

export default class Wizard extends React.Component {
	render() {
		return (
			<WizardWrapper
				className="ps-wizard"
			>
				<Header>
					<ModuleHeader>
						<ModuleHeaderItem>{this.props.header}</ModuleHeaderItem>
					</ModuleHeader>
				</Header>
				<Content className={this.props.contentClassName}>
					{this.props.children}
				</Content>
				<Buttons>
					{
						this.props.prevButtonText && (
							<Button
								text={this.props.prevButtonText}
//								type="light"
							//	iconName="prev"
								name="prev"
								onAction={this.props.prevButtonAction}
							/>
						)
					}
					<Button
						text="ahoj :)"
						name="invisible"
					/>
					{
						this.props.nextButtonText && (
							<Button
								text={this.props.nextButtonText}
//								type="light"
							//	rightIconName="next"
								name="next"
								onAction={this.props.nextButtonAction}
							/>
						)
					}
				</Buttons>
			</WizardWrapper>
		);
	}
}

